import * as yup from 'yup';

export const shippingCreationSchema = yup.object({
  location: yup.string().required('Location name / Shipping name is required'),
  description: yup.string().required('Shipping description is required'),
  fee: yup
    .number()
    .required('Shipping fee is required')
    .min(0, 'Shipping fee must be at least 0'),
});

export type ShippingCreationFormData = yup.InferType<
  typeof shippingCreationSchema
>;
